import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNativeSmallBanner = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 36 36",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 35,
			height: 35,
			rx: 1.5,
			fill: "white",
			stroke: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 3.27295,
			width: 36,
			height: .818182,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 7,
			width: 30,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 20,
			width: 30,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 23.6875,
			width: 13,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 20,
			y: 23.6875,
			width: 13,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 30.6875,
			width: 13,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 20,
			y: 30.6875,
			width: 13,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 27.1875,
			width: 13,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 20,
			y: 27.1875,
			width: 13,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 10.5,
			width: 30,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 14,
			width: 30,
			height: 4.6875,
			rx: .75,
			fill: "var(--format-icon-color, #A8F0F0)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 23,
			y: 17,
			width: 9,
			height: 1,
			rx: .5,
			fill: "white"
		})
	]
});
export default SvgNativeSmallBanner;
